import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// ============================================================
// OwnerBarramentoResponse — resposta da consulta de CPF
// ============================================================

export interface OwnerBarramentoResponse {
  mensagem?: string;
  nome?: string;
  cpf?: string;
  registro?: string;
  cnh?: string;
  dataNascimento?: string;       // LocalDate → ISO string
  validadeCnh?: string;          // LocalDate → ISO string
  categoria?: string;
  ufCnh?: string;
  identidade?: string;
  cidade?: string;
  sexo?: string;
  totalPontos?: number;
  qtdBloqueios?: number;
  cnhVencida?: boolean;
  cnhBloqueada?: boolean;
  cnhRecolhida?: boolean;
  bloqueios?: string[];
  recolhimentos?: string[];
  codigo?: number;
  descricao?: string;
}

// ============================================================
// VehicleBarramentoResponse — resposta da consulta de Placa
// ============================================================

export interface RetornoBarramento {
  codigo: number;
  descricao: string;
}

export interface VehicleBarramentoResponse {
  placa?: string;
  chassi?: string;
  renavam?: string;
  marcaModelo?: string;
  cor?: string;
  tipo?: string;
  especie?: string;
  categoria?: string;
  anoFabricacao?: string;
  anoModelo?: string;
  situacaoCodigo?: string;
  situacaoDescricao?: string;
  uf?: string;
  municipio?: string;
  proprietario?: string;
  cpfCnpjProprietario?: string;
  ultimoAnoExercicio?: string;
  debitoLicenciamento?: string;
  debitoIpva?: string;
  multasValor?: string;
  multasQuantidade?: string;
  restricoesQuantidade?: string;
  observacaoQuantidade?: string;
  inspecaoQuantidade?: string;
  combustivelDescricao?: string;
  isPessoaFisica?: boolean;
  isVeiculoClonado?: boolean;
  isVeiculoSuspeitoClonagem?: boolean;
  transporteClandestino?: any;
  vistoriaAnualEmAtraso?: any;
  veiculoRestricoes?: any[];
  veiculoObservacoes?: any[];
  veiculoInspecoes?: any[];
  retorno?: RetornoBarramento;
  disponivelTransporteEscolar?: boolean;
  isCache?: boolean;
  cacheFrom?: string;
  cacheExpiresAt?: string;
}

// ============================================================
// Serviço
// ============================================================

@Injectable({
  providedIn: 'root'
})
export class BarramentoService {

  /** Base URL: /nucon/api/v1/barramento (controller usa @RequestMapping("nucon/api/v1/barramento")) */
  private readonly baseUrl = `${environment.apiUrl}/nucon/api/v1/barramento`;

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) {}

  /**
   * GET /cpf/{cpf} — Consulta dados do proprietário (condutor) pelo CPF.
   * @param cpf CPF do proprietário (apenas dígitos)
   */
  searchByCpf(cpf: string): Observable<OwnerBarramentoResponse> {
    return this.http.get<OwnerBarramentoResponse>(
      `${this.baseUrl}/cpf/${encodeURIComponent(cpf)}`,
      this.httpOptions
    );
  }

  /**
   * GET /placa/{placa} — Consulta dados do veículo pela placa.
   * @param placa Placa do veículo (ex: ABC1234)
   */
  searchByPlaca(placa: string): Observable<VehicleBarramentoResponse> {
    return this.http.get<VehicleBarramentoResponse>(
      `${this.baseUrl}/placa/${encodeURIComponent(placa)}`,
      this.httpOptions
    );
  }
}
